/** Types copied from platform/packages/ai-mate/conversation-assistant/src/services/assistance-service/types.ts for now */

export var NLPSearchDisclaimerType = /*#__PURE__*/function (NLPSearchDisclaimerType) {
  NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
  return NLPSearchDisclaimerType;
}({});
export var isStreamResponse = function isStreamResponse(message) {
  return message instanceof Object && message.type === 'FINAL_RESPONSE';
};
export var isStreamError = function isStreamError(message) {
  return message instanceof Object && message.type === 'ERROR';
};
export var isStreamAnswerPart = function isStreamAnswerPart(message) {
  return message instanceof Object && message.type === 'ANSWER_PART';
};
export var isStreamTrace = function isStreamTrace(message) {
  return message instanceof Object && message.type === 'TRACE';
};
export var isStreamPluginInvocation = function isStreamPluginInvocation(message) {
  return message instanceof Object && message.type === 'PLUGIN_INVOCATION';
};
export var isStreamFollowUp = function isStreamFollowUp(message) {
  return message instanceof Object && message.type === 'FOLLOW_UP_QUERIES';
};